import {
  Component,
  inject,
  Input,
  OnInit,
  ViewContainerRef,
} from '@angular/core';

import { AppMaterialModule } from 'src/app/modules/app-material.module';
import { CardComponent } from 'src/app/components/shared/card/card.component';

import { ExpanderAnimationComponent } from 'src/app/components/shared/expander-animation/expander-animation.component';

@Component({
  selector: 'app-expandable-card',
  imports: [AppMaterialModule, CardComponent, ExpanderAnimationComponent],
  templateUrl: './expandable-card.component.html',
  styleUrls: ['./expandable-card.component.scss'],
})
export class ExpandableCardComponent implements OnInit {
  public isExpanded: boolean;

  @Input() initiallyOpen: boolean = false;
  @Input() class: string;
  viewRef = inject(ViewContainerRef);
  id: string;

  ngOnInit() {
    this.isExpanded = this.initiallyOpen;
    this.id = self.crypto.randomUUID();
    this.viewRef.element.nativeElement.setAttribute('class', '');
  }
}
